/**
 * Color palette primitives for the Brand 2026 Customer theme.
 *
 * @remarks
 * Prefer using the color theme tokens instead, as they are more stable and less likely to change.
 */
export const palette = {
  purpleBase: '#51285F',
  neutralWhite: '#FFFFFF',
  neutralOffWhite: '#FEFBF7',
  neutralBrandBlack: '#3B3B41',
  greyBase: '#75757C',
  deepPurpleBase: '#31153C',
  blueBase: '#135A72',
  greenBase: '#17830F',
  yellowBase: '#F6BB25',
  redBase: '#B01518',
} as const;
